import { Loader2 } from "lucide-react"

const LoadingState = () => {
  return (
    <div className="py-16 text-center dark:bg-gray-900">
      <Loader2 className="h-10 w-10 animate-spin mx-auto text-primary dark:text-primary" />
      <p className="mt-4 text-muted-foreground dark:text-gray-400">Chargement des données d'inventaire...</p>
    </div>
  )
}

export default LoadingState